// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { BSETBase } from '../Classes/BSETBase';
import { Subcontractors } from '../Classes/Subcontractors';
export class EstimateTab extends BSETBase {
  nonTaxableItem: number;
  isProvidedByOthersEvent: boolean;
  siemensMaterialCost: number;
  mechanicalMaterialCost: number;
  electricalMaterialCost: number;
  outsideMaterialCost: number;
  siemensAtMaterialCost: number;
  actualSiemensMaterialCost: number;
  actualMechanicalMaterialCost: number;
  actualElectricalMaterialCost: number;
  actualOutsideMaterialCost: number;
  actualSiemensAtMaterialCost: number;
  isMarkUpSelected: boolean;
  isFixedPriceSelected: boolean | null;
  baseProjectManagementLaborCost: number;
  baseEngineeringLaborCost: number;
  baseNEngineeringLaborCost: number;
  baseQEngineeringLaborCost: number;
  baseCEngineeringLaborCost: number;
  baseEEngineeringLaborCost: number;
  baseLEngineeringLaborCost: number;
  baseSpecialistLaborCost: number;
  baseMechanicalLaborCost: number;
  baseElectricianLaborCost: number;
  baseProgrammingLaborCost: number;
  baseGraphicsLaborCost: number;
  baseDigitalDeploymentLaborCost: number;
  projectManagementLaborCost: number;
  engineeringLaborCost: number;
  specialistLaborCost: number;
  mechanicalLaborCost: number;
  electricianLaborCost: number;
  programmingLaborCost: number;
  graphicsLaborCost: number;
  digitalDeploymentLaborCost: number;
  nEngineeringLaborCost: number;
  qEngineeringLaborCost: number;
  cEngineeringLaborCost: number;
  eEngineeringLaborCost: number;
  lEngineeringLaborCost: number;
  projectManagementLaborHour: number;
  engineeringLaborHour: number;
  networkEngineeringLaborHour: number;
  qualificationEngineeringLaborHour: number;
  cyberSecEngineeringLaborHour: number;
  energyEngineeringLaborHour: number;
  lEngineeringLaborHour: number;
  specialistLaborHour: number;
  mechanicalLaborHour: number;
  electricianLaborHour: number;
  programmingLaborHour: number;
  graphicsLaborHour: number;
  digitalDeploymentLaborHour: number;
  totalProgTaskHours: number;
  totalGrapTaskHour: number;
  totalDdepTaskHour: number;
  miscCost: number;
  riskCost: number;
  autoRiskCost: number;
  travelExpenseCost: number;
  mechFeeCost: number;
  subcontractorFeeCost: number;
  productivityReserveCost: number;
  subContractorCostItemGMPercent: number;
  subContractorCostItemSellPrice: number;
  subContractorCostItemTDC: number;
  taxCost: number;
  subTotalsCost: number;
  subTotalSellprice: number;
  totalWarrantyCost: number;
  totalShippingCost: number;
  siemensMatWarrantyRate: number;
  soldASSellPrice: number;
  isLastModifiedSiemensMaterialSellPrice: boolean;
  isLastModifiedSiemensMaterialSHSellPrice: boolean;
  isLastModifiedSiemensMaterialWarrantySellPrice: boolean;
  isLastModifiedOutsideMaterialSellPrice: boolean;
  isLastModifiedOutsideMaterialSHSellPrice: boolean;
  isLastModifiedOutsideMaterialWarrantySellPrice: boolean;
  isLastModifiedMechMaterialSellPrice: boolean;
  isLastModifiedMechMaterialSHSellPrice: boolean;
  isLastModifiedMechMaterialWarrantySellPrice: boolean;
  isLastModifiedElecMaterialSellPrice: boolean;
  isLastModifiedElecMaterialSHSellPrice: boolean;
  isLastModifiedElecMaterialWarrantySellPrice: boolean;
  isLastModifiedPMSellPrice: boolean;
  isLastModifiedENGSellPrice: boolean;
  isLastModifiedNENGSellPrice: boolean;
  isLastModifiedQENGSellPrice: boolean;
  isLastModifiedCENGSellPrice: boolean;
  isLastModifiedEENGSellPrice: boolean;
  isLastModifiedLENGSellPrice: boolean;
  isLastModifiedSPECSellPrice: boolean;
  isLastModifiedMECHellPrice: boolean;
  isLastModifiedELECSellPrice: boolean;
  isLastModifiedProgSellPrice: boolean;
  isLastModifiedGrapSellPrice: boolean;
  isLastModifiedDdepSellPrice: boolean;
  isLastModifiedMiscSellPrice: boolean;
  isLastModifiedTravelSellPrice: boolean;
  isLastModifiedRiskSellPrice: boolean;
  isLastModifiedAutoRiskSellPrice: boolean;
  isLastModifiedMechFeeSellPrice: boolean;
  isLastModifiedSubcontractorFeeSellPrice: boolean;
  isLastModifiedProductivityReserveSellPrice: boolean;
  subsidy: number;
  subsidyMaterial: number;
  technologyFeeCost: number;
  technologyFeeSellprice: number;
  totalSubcontractorsCost: number;
  materialCostSellPrice: number;
  estimateTabSubContractors: Array<Subcontractors>;
}
